import React, { useEffect } from "react";
import { generateGuid } from "./kendo_common";

export const KendoTreeTable = ({
  noteContent = "",
  noteLabel = "",
  name,
  parentTableUrl,
  parentTableData,
  parentTableColumns,
  parentpaggable = true,
  childpaggable = false,
  schema,
  childSchema,
  childTableUrl,
  childTableColumns,
  serverPaging,
  serverFiltering,
  serverSorting,
  filterable,
  sortable,
  scrollable,
  showParentOptions,
  showParentAdd = false,
  onParentAddClick,
  onParentEditClick,
  onParentDeleteClick,
  showChildOptions,
  onChildEditClick,
  onChildDeleteClick,
  showParentEdit,
  showParentDelete,
  showChildEdit,
  showChildDelete,
  showChildAddButton,
  showChildSearch,
  onAddChild,
  refreshWhen,
  enableRowReorderable,
  onRowReorder,
}) => {
  var guId = generateGuid();
  useEffect(() => {
    //kenod grid options
    if (showParentOptions || false) {
      var parentId = parentTableColumns[0].field;
      var options = {
        template: function (e) {
          let add = "";
          if (!(showParentAdd == false)) {
            add = `<a href="javascript:void(0)"  id="k-grd-${name}-add-${e[parentId]}" title="Edit"><i class="k-icon k-i-pencil k-grid-edit m-2"></i></a>`;
          }
          let edit = "";
          if (!(showParentEdit == false)) {
            edit = `<a href="javascript:void(0)"  id="k-grd-${name}-edit-${e[parentId]}" title="Add"><i class="k-icon k-i-plus-circle k-grid-edit m-2"></i></a>`;
          }

          let del = "";
          if (!(showParentDelete == false)) {
            del = ` <a href="javascript:void(0)"  id="k-grd-${name}-delete-${e[parentId]}" title="Delete"><i class="k-icon k-i-trash k-grid-delete m-2" ></i></a>`;
          }
          return `<div style='text-align:center'>
                  ${add}
                  ${edit}
                  ${del}
                </div>`;
        },

        title:
          showParentAdd + showParentEdit + showParentDelete > 1
            ? "Options"
            : "Option",
        width: "100px",
      };

      if (parentTableColumns.find((e) => e.title == "Option") == null) {
        parentTableColumns.push(options);
      }
    }

    if (showChildOptions) {
      var Id = childTableColumns[0].field;
      var options = {
        template: function (e) {
          let edit = "";
          if (!(showChildEdit === false)) {
            edit = `<a href="javascript:void(0);" id="k-grd-${name}-child-edit-${e[Id]}" title="Edit"><i class="k-icon k-i-pencil k-grid-edit m-2"></i></a>`;
          }
          let del = "";
          if (!(showChildDelete == false)) {
            del = `<a href="javascript:void(0)" id="k-grd-${name}-child-delete-${e[Id]}" title="Delete"><i class="k-icon k-i-trash k-grid-delete m-2" ></i></a>`;
          }

          return `<div style="text-align:center">
                ${edit}
                ${del}
                </div>`;
        },

        title: onChildEditClick && onChildDeleteClick ? "Options" : "Option",
        width: "100px",
      };

      if (childTableColumns.find((e) => e.title == "Option") == null) {
        childTableColumns.push(options);
      }
    }

    let grd = $(`#${name}`).data("kendoGrid");

    if (grd) {
      grd.destroy();
    }

    $(`#${name}`)
      .kendoGrid({
        dataSource: {
          transport: parentTableUrl && {
            read: parentTableUrl,
          },
          data: (!parentTableUrl && parentTableData) || [],
          pageSize: 10,
          serverPaging: serverPaging || false,
          serverSorting: serverSorting || false,
        },
        scrollable: scrollable || false,
        filterable: filterable || false,
        sortable: sortable || true,
        pageable: !(parentpaggable == false) && {
          pageSizes: [5, 10, 50, 100],
          buttonCount: 5,
        },
        toolbar: ["search"],

        detailInit: function (e) {
          let parentRow = e && e.data;
          let addBtn = "";
          if (showChildAddButton) {
            addBtn = $(
              `<button type="submit" class="butn-dark2 m-2" style="float:right;margin-right:6px;color:white;"><span>Add</span></button>`
            );
            addBtn.click(function () {
              if (e) {
                onAddChild(e.data);
              }
            });
          }
          if (childTableUrl) {
            let getId = parentTableColumns[0].field;
            let primaryId;
            if (e && e.data) {
              primaryId = e.data[getId];
            }
            let childApiurl = childTableUrl.replace(`{${getId}}`, primaryId);
            $("<div/>")
              .appendTo("<div/>")
              .append(addBtn)
              .appendTo(e.detailCell)
              .kendoGrid({
                dataSource: {
                  transport: {
                    read: childApiurl,
                  },
                  schema: {
                    model: {
                      field: childSchema,
                    },
                  },

                  serverPaging: false,
                  serverSorting: false,
                  serverFiltering: false,
                },
                toolbar: showChildSearch
                  ? [
                      "search",
                      {
                        text: "Refresh",
                        className: "btn-refresh display-none",
                      },
                      {
                        template: `
                      <span style="background-color: yellow; ">
                        ${noteLabel}
                      </span>
                      <span>${noteContent}</span>
                    `,
                      },
                    ]
                  : [
                      {
                        text: "Refresh",
                        className: "btn-refresh display-none",
                      },
                      {
                        template: `
                      <span style="background-color: yellow; ">
                        ${noteLabel}
                      </span>
                      <span>${noteContent}</span>
                    `,
                      },
                    ],

                scrollable: false,
                sortable: true,
                pageable: !(childpaggable == false) && {
                  pageSizes: [5, 10, 50, 100],
                  buttonCount: 5,
                },
                reorderable: {
                  rows: enableRowReorderable,
                },
                rowReorder: function (e) {
                  if (enableRowReorderable && onRowReorder) {
                    let childGrid = $(e.sender.element).data("kendoGrid");
                    if (!childGrid) return;

                    // Retrieve the reordered row's ID
                    let pId = $(e.row).find("td:first").text();

                    // Get the old and new rows using indices
                    let newRow = childGrid.items().eq(e.oldIndex);
                    let oldRow = childGrid.items().eq(e.newIndex);

                    // Trigger the callback with relevant data
                    onRowReorder({
                      pid: pId,
                      oldIndex: e.oldIndex,
                      oldRow: oldRow,
                      newIndex: e.newIndex,
                      newRow: newRow,
                    });
                  }
                },
                columns: childTableColumns,
                dataBound: function (e) {
                  if (showChildOptions) {
                    var grid = this;
                    grid.dataSource.data().forEach(function (dataItem) {
                      if (!(showChildEdit === false)) {
                        $(`#k-grd-${name}-child-edit-${dataItem[Id]}`).on(
                          "click",
                          function (e) {
                            e.preventDefault();
                            onChildEditClick({
                              parent: parentRow,
                              child: dataItem,
                            });
                            e.stopPropagation();
                          }
                        );
                      }
                      if (!(showChildDelete === false)) {
                        $(`#k-grd-${name}-child-delete-${dataItem[Id]}`).on(
                          "click",
                          function () {
                            onChildDeleteClick(dataItem);
                          }
                        );
                      }
                    });
                  }
                },
              });
          }
        },
        dataBound: function (e) {
          if (showParentOptions) {
            var grid = this;
            grid.dataSource.data().forEach(function (dataItem) {
              if (!(showParentAdd == false)) {
                $(`#k-grd-${name}-add-${dataItem[parentId]}`).on(
                  "click",
                  function (e) {
                    e.preventDefault();
                    onParentAddClick(dataItem);
                    e.stopPropagation();
                  }
                );
              }

              if (!(showParentEdit == false)) {
                $(`#k-grd-${name}-edit-${dataItem[parentId]}`).on(
                  "click",
                  function (e) {
                    e.preventDefault();
                    onParentEditClick(dataItem);
                    e.stopPropagation();
                  }
                );
              }

              if (!(showParentDelete === false)) {
                $(`#k-grd-${name}-delete-${dataItem[parentId]}`).on(
                  "click",
                  function (e) {
                    e.preventDefault();
                    onParentDeleteClick(dataItem);
                    e.stopPropagation();
                  }
                );
              }
            });
          }
        },
        noRecords: {
          template: `
            <div style="display: flex; justify-content: center; align-items: center; height: 100%; text-align: center; font-weight: bold;">
              No data available
            </div>`,
        },

        columns: parentTableColumns,
      })
      .on("click", ".btn-refresh", function (e) {
        var childGrid = $(e.target).closest(".k-grid").data("kendoGrid");
        childGrid.dataSource.read();
      });
  }, [refreshWhen]);

  return (
    <>
      <div style={{ display: "none" }} id={"reload-" + name}></div>
      <div id={`${name}`}></div>
    </>
  );
};
